import React, { useContext } from 'react'

import { ReviewContext } from '../contexts/ReviewContextProvider'

import { ReviewContextType } from '../types'

export const useReview = () => useContext( ReviewContext ) as ReviewContextType
